class RelatedArticles extends HTMLElement {
  constructor() {
    super();

    this.Slide = this.querySelectorAll('.js-slider');
    console.log(this.Slide)
    this.Slide.forEach(slide => {
      this.swiperRelatedArticles = new Swiper(slide, {
        loop: true,
        navigation: {
          nextEl: ".related-articles__button-next",
          prevEl: ".related-articles__button-prev",
        },
        breakpoints: {
          990: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          750: {
            slidesPerView: 2,
            spaceBetween: 24,
          }
        },
      });
    });
  }
}
customElements.define("related-articles", RelatedArticles);